import React from "react";

import { Input } from "./input";

interface IRealCurrencyInputProps {
  value: number;
  onChange: (centavos: number) => void;
  placeholder?: string;
  className?: string;
  id?: string;
  disabled?: boolean;
}

export const RealCurrencyInput: React.FC<IRealCurrencyInputProps> = ({
  value = 0,
  onChange,
  placeholder = "R$ 0,00",
  className,
  id,
  disabled = false,
}) => {
  const formatCurrency = (centavos: number): string => {
    const reais = centavos / 100;

    return reais.toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = event.target.value;

    const numbersOnly = inputValue.replace(/\D/g, "");
    const centavos = parseInt(numbersOnly) || 0;

    onChange(centavos);
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    const key = event.key;

    if (
      !/[0-9]/.test(key) &&
      ![
        "Backspace",
        "Delete",
        "Tab",
        "Enter",
        "ArrowLeft",
        "ArrowRight",
      ].includes(key)
    ) {
      event.preventDefault();
    }

    if (/[0-9]/.test(key)) {
      event.preventDefault();
      const digit = parseInt(key);
      const newValue = value * 10 + digit;

      onChange(newValue);
    }
  };

  const displayValue = formatCurrency(value);

  return (
    <div className="space-y-1">
      <Input
        value={displayValue}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        id={id}
        placeholder={placeholder}
        className={className}
        disabled={disabled}
        onPaste={(e) => e.preventDefault()}
      />
    </div>
  );
};
